const collegeConfig = {
  // College Information
  collegeName: "SGT Medical College Hospital & Research Institute",
  shortName: "SGT",
  appName: "E-Logbook System",

  // Contact Information
  supportEmail: "support@sgtlogbook.com",
  adminContact: "admin@sgtlogbook.com",
  
  // Branding
  logo: require('../components/assets/logo.png'),
  favicon: '/favicon.ico',
  
  // Theme Colors (Inspired by Logo - Orange, Red & Gold)
  theme: {
    // Primary (main medical blue)
    primaryColor: '#1e56a0',
    primaryColorLight: '#3d74c5',
    primaryColorDark: '#123a6b',

    // Secondary (golden contrast instead of blue)
    secondaryColor: '#d4a017',
    secondaryColorLight: '#e6b84a',
    secondaryColorDark: '#9c7410',

    // Accent (slightly richer orange-gold for highlights)
    accentColor: '#ff9f1c',

    // Highlight (UI interaction color)
    highlightRed: '#ff9f1c',

    // Status colors
    successColor: '#2e8b57',
    warningColor: '#f4a261',
    errorColor: '#c44536',
    infoColor: '#1e56a0',

    // Backgrounds (neutral to avoid color overload)
    backgroundColor: '#f9fafb',
    backgroundGradient: 'linear-gradient(135deg, #f9fafb 0%, #f1f5f9 100%)',
    cardBackground: '#ffffff',

    // Text
    textPrimary: '#0b1320',
    textSecondary: '#334155',
    textLight: '#94a3b8',

    // Borders & shadows
    borderColor: '#e5e7eb',
    shadowColor: 'rgba(0,0,0,0.08)',
  },
  
  // Demo Videos (relative to /public — set to null to hide the Watch Demo button)
  demoVideos: {
    login:   '/assets/videos/login-demo.mp4',
    student: '/assets/videos/student-demo.mp4',
    teacher: '/assets/videos/prof-demo.mp4',
  },

  // App Store Links
  // Set to null to show "Coming Soon", or provide the full store URL
  appLinks: {
    android: 'https://play.google.com/store/apps/details?id=com.sgt.elogbook', // e.g. 'https://play.google.com/store/apps/details?id=com.yourapp'
    ios: 'https://apps.apple.com/app/sgt-e-logbook/id6767151183',     // e.g. 'https://apps.apple.com/app/your-app/id1234567890'
  },

  // Feature flags
  features: {
    forgotPassword: true,
    rememberMe: false
  },

  // App Settings
  version: '1.2.0',
  copyrightYear: '2026',
  
  // API Endpoints
  api: {
    baseURL: process.env.REACT_APP_API_URL || 'https://sgtlogbook.com/api',
    timeout: 10000,
  },
};

// Export theme as CSS variables for easy use in CSS files
export const generateCSSVariables = () => {
  const variables = {};
  Object.entries(collegeConfig.theme).forEach(([key, value]) => {
    const cssVarName = `--${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
    variables[cssVarName] = value;
  });
  return variables;
};

export default collegeConfig;